import React from 'react';
import cx from 'classnames';

function OnboardingTitle({ className, title }) {
  return <h3 className={cx(className, 'mb-6 text-xl font-bold text-center pb-4')}>{title}</h3>;
}

export default React.memo(OnboardingTitle);
